const { MODE: ENVIRONMENT, VITE_API_BASE_PATH } = import.meta.env;

export { ENVIRONMENT, VITE_API_BASE_PATH };
